import { render } from "./BlankPageSalesFour.vue?vue&type=template&id=137b4ef9&scoped=true"
import script from "./BlankPageSalesFour.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesFour.vue?vue&type=script&lang=js"

import "./BlankPageSalesFour.vue?vue&type=style&index=0&id=137b4ef9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137b4ef9"]])

export default __exports__